import * as angular from 'angular';
import { ComponentDefinition, Application, EditionInfo, ApplicationDto } from '../../../models';
import { ICurrentApplicationService, IApplicationService, ILoggerService, IAuthenticationService } from '../../../services';
import { applicationSaved } from '../../../common';

class DocumentationApplicationStateController implements angular.IComponentController {
    application: Application;
    category: string;
    editionInfo: EditionInfo;
    isEditMode: boolean;
    isLoadingCurrent: boolean;

    readonly hasEditRole: boolean;
    readonly isLoading: boolean;

    private userName: string;

    static $inject = ['$rootScope', 'currentApplicationService', 'applicationService', 'authenticationService', 'loggerService'];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _currentApplicationService: ICurrentApplicationService,
        private _applicationService: IApplicationService,
        private _authenticationService: IAuthenticationService,
        private _loggerService: ILoggerService
    ) {}

    $onInit() {
        this.loadItem();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['isLoading']?.currentValue) {
            this.isLoadingCurrent = this.isLoading;
        }
    }

    loadItem(): any {
        this.isLoadingCurrent = true;
        this.editionInfo = {
            isEditAllowed: false,
            message: 'Loading still in progress'
        };
        const currentAppConfig = this._currentApplicationService.getApplicationConfiguration();
        this._applicationService
            .getByGuid(currentAppConfig.guid, true)
            .then((applicationDto) => {
                if (applicationDto) {
                    this.application = applicationDto.application;
                }
                // #28938: Disable edit button when application is online
                const authentication = this._authenticationService.authentication;
                this.userName = authentication.userName;
                return this._applicationService.getOneWithInformation(this.userName, currentAppConfig.guid);
            })
            .then((data) => {
                this.editionInfo =
                    !!data.item2.hasActiveJobs && !this.application.isIdleMode
                        ? {
                              isEditAllowed: false,
                              message: 'Application documentation cannot be modified because there are active tasks',
                              redirect: {
                                  url: 'jobsDefinition'
                              }
                          }
                        : { isEditAllowed: true };
            })
            .catch((error) => {
                this._loggerService.logError(`Cannot retrieve application with guid "${currentAppConfig.guid}"`);
            })
            .finally(() => (this.isLoadingCurrent = false));
    }

    save(): void {
        this._applicationService
            .update(this.application)
            .then((data) => {
                this._$rootScope.$broadcast(applicationSaved, data.application);
                this._loggerService.logSuccess('Application documentation successfully updated');
            })
            .catch((error) => {
                this._loggerService.logError(`Cannot save application "${this.application.name}" [guid:"{this.application.guid}"]`);
            });
    }
}

export const wtDocumentationApplicationState: ComponentDefinition = {
    componentId: 'wtDocumentationApplicationState',
    controller: DocumentationApplicationStateController,
    controllerAs: 'vm',
    template: require('./documentationApplicationState.component.html'),
    bindings: {
        hasEditRole: '<',
        isLoading: '<'
    }
};
